import { useIntl } from "react-intl";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField, TextFieldProps } from "@mui/material";
import { EnrollmentAssigner } from "services/organizationPortalClient";

type SelectAssignedByProps = {
  value?: EnrollmentAssigner;
  onChange: (v?: EnrollmentAssigner) => void;
  textFieldProps?: Partial<TextFieldProps>;
};

export default function SelectAssignedBy({
  value,
  onChange,
  textFieldProps,
}: SelectAssignedByProps) {
  const { formatMessage: t } = useIntl();

  const handleValueChange = (_: any, value: any | null) => {
    if (onChange) onChange(value?.id);
  };

  let data = [
    { id: EnrollmentAssigner.SelfUser, label: "Self-User" },
    { id: EnrollmentAssigner.Administrator, label: "Administrator" },
  ];
  const autoCompleteValue = value
    ? data.find((d) => d.id === value) ?? null
    : null;

  return (
    <Autocomplete
      disablePortal
      options={data}
      value={autoCompleteValue}
      onChange={handleValueChange}
      size="small"
      renderInput={(params) => (
        <TextField
          {...params}
          {...textFieldProps}
          InputProps={{
            ...textFieldProps?.InputProps,
            ...params.InputProps,
          }}
          label={t({ id: "assignedBy" })}
          fullWidth
        />
      )}
    />
  );
}
